window.addEventListener('DOMContentLoaded', function () {
  const checks = document.querySelectorAll('input[name^="AD-8-q"]');
  const resultText = document.querySelector('.j-text');
  let text = "您選擇「是，有改變」的項目有<span>0</span>項，尚無需接受專科醫師進一步評估"

  resultText.innerHTML = text;

  checks?.forEach((input) => {
    input.addEventListener('change', function (event) {
      const checkeds = document.querySelectorAll('input[name^="AD-8-q"]:checked');

      const inputValues = [...checkeds].map(checked => checked.value);

      const count = inputValues.filter(value => value === '1').length;

      text = "您選擇「是，有改變」的項目有<span>" + count + "</span>項，尚無需接受專科醫師進一步評估"

      if (count >= 2) {
        text = "您選擇「是，有改變」的項目有<span>" + count + "</span>項，需接受專科醫師進一步評估"
      }

      resultText.innerHTML = text;
    })
  })
});
